var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraResetMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 28C9.33464 28 9.33464 25.6776 9.33464 24.4575C9.33464 24.1646 9.21826 23.8836 9.01111 23.6765L7.44902 22.1144C6.94892 21.6143 6.66797 20.936 6.66797 20.2288V18.4379C6.66797 17.7307 6.94892 17.0524 7.44902 16.5523L9.33464 14.6667V9.33333C9.33464 8.59695 9.93159 8 10.668 8C11.4043 8 12.0013 8.59695 12.0013 9.33333V14.6667C12.0013 13.9303 12.5983 13.3333 13.3346 13.3333C14.071 13.3333 14.668 13.9303 14.668 14.6667C14.668 13.9303 15.2649 13.3333 16.0013 13.3333C16.7377 13.3333 17.3346 13.9303 17.3346 14.6667V16C17.3346 15.2636 17.9316 14.6667 18.668 14.6667C19.4043 14.6667 20.0013 15.2636 20.0013 16V18",
    stroke: "#8CB5F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 17.3359L9.33594 14.6693",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 16L14.668 14.6667",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L12 14.6667",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 9.33594C14.668 7.1268 12.8771 5.33594 10.668 5.33594C8.45883 5.33594 6.66797 7.1268 6.66797 9.33594",
    stroke: "#2264C2",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 9.33073C17.3333 5.64883 14.3486 2.66406 10.6667 2.66406C6.98477 2.66406 4 5.64883 4 9.33073",
    stroke: "#2264C2",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.3984V23.3984C16 22.2939 16.8954 21.3984 18 21.3984V21.3984C19.1046 21.3984 20 22.2939 20 23.3984V23.7929C20 24.7959 19.4987 25.7326 18.6641 26.289L16 28.0651H20",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 28.0651L26.668 21.3984",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 21.3346L26.5547 28.1321",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraResetMobile);
export default __webpack_public_path__ + "static/media/CameraResetMobile.a05a99cd49fda94433cbd8896c554f8b.svg";
export { ForwardRef as ReactComponent };